<template>
  <div class="property_section">
    <div class="property_section--header">
      <h5 class="property_section--heading text-uppercase">{{ heading }}</h5>
      <button-link
        v-if="showEditButton"
        @click="$emit('clicked')"
        :loading="isEditButtonLoading"
        class="ml-100"
      >Edit Details</button-link>
    </div>

    <div v-if="upgradeRequired" class="property_section--content" :class="{'is-highlighted': showEditButton}">
      <p class="property_section--upgrade">
        Upgrade required to see this data.
        <a @click="openBillingPortal">Upgrade your account today</a>
      </p>
    </div>

    <div v-else class="property_section--content columns is-multiline" :class="{'is-highlighted': showEditButton}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PropertyModalSection",
  props: {
    heading: {
      type: String,
      required: true,
    },
    upgradeRequired: {
      type: Boolean,
      default: false,
    },
    showEditButton: {
      type: Boolean,
      default: false,
    },
    isEditButtonLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.property_section {
  margin-bottom: 1.5rem;

  &--header {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    padding: 0 14px 4px;
    border-bottom: 1px solid $borderDark;
  }

  &--heading {
    font-size: 0.875rem;
    font-weight: bold;
  }

  &--upgrade {
    margin: 2rem 0;
    text-align: center;
    font-style: italic;
  }

  &--content {
    margin: 0;
    padding: 0 14px;

    &.is-highlighted {
      background-color: $background;
    }
  }
}
</style>
